import $ from 'jquery';
import rimg from 'rimg-shopify';
import ImageZoom from '../utils/ImageZoom';
import Rte from '../utils/Rte';
import VariantHelper from '../utils/VariantHelper';

export default class StaticProduct {
  constructor(section) {
    this.el = section.el;
    this.$el = $(section.el);
    this.data = section.data;

    this.validate();

    this._bindEvents();
    this.timeouts = [];

    this.images = JSON.parse($('[data-images]', this.$el).text());

    this.$el.find('.rte').each((index, rte) => { new Rte({ el: rte }); });

    if (Shop.currencySwitcher) {
      $('.currency-switcher').trigger('switch-currency');
    }
  }

  _bindEvents() {
    this.events = [
      this.$el.find('.product-options select').on('change.productview', e => this.updateVariantLabel(e, $(this))),
      this.$el.find('.product-thumbnails img').on('click.productview', e => this.swapImage(e, $(this))),
      this.$el.find('.product-form').on('submit.productview', e => this.addToCart(e)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.productview'));
  }

  validate() {
    this.product = this.data.product;
    this.section = this.data.section;
    this.cartText = this.data.cartText;
    this.zoomEnabled = this.section.enable_zoom;
    this.enableSendToCart = this.section.enable_send_to_cart;
    this.variants = this.product.variants;
    this.minimumPriceArea = $('.product-price-minimum', this.$el);
    this.addingToCart = false;

    this.productArea = $('.product-wrap', this.$el);
    this.$productForm = $('.product-form', this.productArea);
    this.formID = parseInt(this.$productForm.attr('data-product-form'), 10);
    this.productSelect = `#product-select-${this.formID}`;
    this.$priceArea = $('.product-form .product-price', this.productArea);
    this.$addToCartButton = $('.submit-wrapper input', this.productArea);
    this.$productThumbnails = $('.product-images .product-thumbnails img', this.productArea);

    const $productJSON = $(`[data-product-json-${this.formID}]`, this.productArea);
    const $productSettings = $(`[data-product-settings-${this.formID}]`, this.productArea);

    this.productJSON = this.product;
    this.productSettings = this.data.productSettings;
    this.$variantDropdowns = $(`[data-option-select=${this.formID}]`, this.productArea);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;

    if ($('.product-form', this.$el).length) {
      this.setupVariants();
    }

    if (this.zoomEnabled && $('.product-images', this.$el).length) {
      this.zoomView = new ImageZoom({ el: $('.product-main-image', this.$el) });
    }

    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  swapImage(e, newImage) {
    const imageId = $(e.target).data('image-id');

    const $nextImageWrapper = $(this.images[imageId]);
    $nextImageWrapper.css('display', 'none');
    const $nextImages = $nextImageWrapper.find('img');

    const $imageWrapper = $('.product-main-image [data-product-image]', this.$el);
    const $images = $imageWrapper.find('img');

    rimg.unwatch($images[0]);

    $nextImages.one('load', () => {
      $imageWrapper.remove();
      $nextImageWrapper.css('display', '');
      rimg.watch($nextImages[0]);

      if (this.zoomEnabled) {
        const $productMainImage = $('.product-main-image', this.$el);
        $productMainImage.trigger('cancel-zoom');
        $productMainImage.trigger('prepare-zoom');
      }
    });

    $imageWrapper.after($nextImageWrapper);
  }

  setupVariants() {
    const variantHelperDefaults = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
    };

    if (this.$variantDropdowns.length) {
      let dropdownSettings = {
        $selector: this.$variantDropdowns,
        type: 'select',
      };

      dropdownSettings = window.ThemeUtils.extend(variantHelperDefaults, dropdownSettings);

      this.variantHelpers = new VariantHelper(dropdownSettings);
    }
  }

  updateVariantLabel(e, select) {
    select = e ? e.target : select;

    select = $(select);
    const selectedVariant = select.find('option:selected').val();

    select.prev('.select-text').html(selectedVariant);
  }

  addToCart(e) {
    e.preventDefault();

    $('.error-message', this.$el).remove();

    Shopify.addItemFromForm(e.target.getAttribute('id'), (data) => {
      // The product was successfully added
      // Cart Ajax: show message and update cart count
      if (this.enableSendToCart) {
        window.location.href = '/cart';
        return;
      }

      $('.cart-count').addClass('active-cart');

      const message = this.data.message
        .replace('{{ product }}', `${this.product.title}`)
        .replace('{{ cart_link }}', `<a href='/cart'>${this.data.cartLink}</a>`)
        .replace('{{ continue_link }}', `<a href='/collections/all'>${this.data.continueLink}</a>`)
        .replace('{{ checkout_link }}', `<a href='/checkout'>${this.data.checkoutLink}</a>`);

      this.timeouts.push(setTimeout(() => {
        this.$el.find('.product-message', this.$el).html(message).addClass('success-message').removeClass('error-message');
        return this.updateCart(data);
      },
      500));
    });
  }

  updateCart(newItem) {
    return Shopify.getCart((cart) => {
      const cartCount = cart.item_count;
      const cartCountText = cart.item_count === 1 ? this.cartText[0] : this.cartText[1];
      $('.bag-count').text(cart.item_count);
      $('.bag-text').html(cartCountText);
      const ref = cart.items;
    });
  }

  handleErrors(response) {
    const error = JSON.parse(response.responseText);

    $('.product-form', this.$el).append(`<div class=\"error-message\">${error.description}</div>`);
  }

  onSectionUnload() {
    this._unbindEvents();
    if (this.zoomView) {
      this.zoomView.unload();
    }
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
